import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// react-bootstrap components
import { Collapse, Nav } from "react-bootstrap";

import { properties } from "../../config/ClientConfigurations.js";
import { apiService } from "../../service/ApiService";

import CreditsItem from "components/Custom/CreditsItem.js";
import { useTranslation } from "react-i18next";

function HipposSidebar({ routes = [], image = "", background = "black" }) {
  const { t } = useTranslation();
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the user collapse
  const [userCollapseState, setUserCollapseState] = React.useState(false);
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  React.useEffect(() => {
    setState(getCollapseStates(routes));
  }, []);
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes prop
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  };
  const getRouteName = (route) => (route.translationKey ? t(route.translationKey) : route.name);
  const getRouteMini = (route) => {
    if (!route.translationKey) return route.mini;

    return getRouteName(route)
      .split(/\s+/)
      .map((word) => word.charAt(0))
      .join("")
      .slice(0, 2)
      .toLocaleUpperCase();
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <Nav.Item className={getCollapseInitialState(prop.views) ? "active" : ""} as="li" key={key}>
            <Nav.Link
              className={state[prop.state] ? "collapsed" : ""}
              data-toggle="collapse"
              onClick={(e) => {
                e.preventDefault();
                setState({ ...state, ...st });
              }}
              aria-expanded={state[prop.state]}
            >
              <i className={prop.icon}></i>
              <p>
                {getRouteName(prop)} <b className="caret"></b>
              </p>
            </Nav.Link>
            <Collapse in={state[prop.state]}>
              <div>
                <Nav as="ul">{createLinks(prop.views)}</Nav>
              </div>
            </Collapse>
          </Nav.Item>
        );
      }
      return (
        <Nav.Item className={activeRoute(prop.layout + prop.path)} key={key} as="li">
          <Nav.Link to={prop.layout + prop.path} as={Link}>
            {prop.icon ? (
              <>
                <i className={prop.icon} />
                <p>{getRouteName(prop)}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini">{getRouteMini(prop)}</span>
                <span className="sidebar-normal">{getRouteName(prop)}</span>
              </>
            )}
          </Nav.Link>
        </Nav.Item>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  return (
    <>
      <div className="sidebar mb-0" data-color={background} data-image={image}>
        <div className="sidebar-wrapper">
          <div className="logo">
            <a className="simple-text logo-mini" href="/admin/dashboard">
              <div className="logo-img">
                <img src={require("assets/img/w-transparent.svg").default} alt="react-logo" />
              </div>
            </a>
            <a className="simple-text logo-normal" href="#">
              {properties.appDashboardName}
            </a>
          </div>
          <div className="user">
            <div className="photo">
              <img
                alt={apiService.isSuperAdmin() ? "Admin" : apiService.isReseller() ? "Reseller" : "Client"}
                src={
                  apiService.isSuperAdmin()
                    ? require("assets/img/admin-avatar.png")
                    : apiService.isReseller()
                    ? require("assets/img/reseller-avatar.png")
                    : require("assets/img/client-avatar.png")
                }
              />
            </div>
            <div className="info">
              <a
                className={userCollapseState ? "collapsed" : ""}
                data-toggle="collapse"
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setUserCollapseState(!userCollapseState);
                }}
                aria-expanded={userCollapseState}
              >
                <span>
                  {apiService.getFullName()} <b className="caret"></b>
                </span>
              </a>
              <Collapse id="collapseExample" in={userCollapseState}>
                <div>
                  <Nav as="ul">
                    <li>
                      <a className="profile-dropdown">
                        <CreditsItem />
                      </a>
                    </li>
                    <li>
                      <a className="profile-dropdown" href={`/admin/user/${apiService.getId()}`}>
                        <span className="sidebar-mini">{t("navigation.profileShort")}</span>
                        <span className="sidebar-normal">{t("navigation.profile")}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-danger profile-dropdown"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          apiService.logout();
                        }}
                      >
                        <span className="sidebar-mini">{t("navigation.logoutShort")}</span>
                        <span className="sidebar-normal">{t("navigation.logout")}</span>
                      </a>
                    </li>
                  </Nav>
                </div>
              </Collapse>
            </div>
          </div>
          <Nav as="ul">{createLinks(routes)}</Nav>
        </div>
        {/*<div*/}
        {/*  className="sidebar-background"*/}
        {/*  style={{*/}
        {/*    backgroundImage: "url('" + image + "')"*/}
        {/*  }}*/}
        {/*></div>*/}
      </div>
    </>
  );
}

let linkPropTypes = {
  path: PropTypes.string,
  layout: PropTypes.string,
  name: PropTypes.string,
  translationKey: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

// Disabled
// Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.
// HipposSidebar.defaultProps = {
//   image: "",
//   background: "black",
//   routes: []
// };

HipposSidebar.propTypes = {
  image: PropTypes.string,
  background: PropTypes.oneOf(["black", "azure", "green", "orange", "red", "purple"]),
  routes: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        ...linkPropTypes,
        icon: PropTypes.string,
      }),
      PropTypes.shape({
        collapse: true,
        path: PropTypes.string,
        name: PropTypes.string,
        state: PropTypes.string,
        icon: PropTypes.string,
        views: PropTypes.shape({
          ...linkPropTypes,
          mini: PropTypes.string,
        }),
      }),
    ])
  ),
};

export default HipposSidebar;
